export default __webpack_public_path__ + "static/media/srisailamDeitieOne.56a813e4.png";